import { api } from "@/api/axios";

export interface PilotAccessRequest {
  church_name: string;
  church_city: string;
  church_state: string;

  contact_first_name: string;
  contact_last_name: string;
  contact_email: string;

  contact_phone?: string | null;
  church_website?: string | null;
  church_size_range?: string | null;
  estimated_member_count?: number | null;

  current_system?: string | null;
  primary_use_case?: string | null;
  preferred_onboarding_date?: string | null;
  notes?: string | null;

  source?: "WEBSITE";
}

export async function submitPilotAccessRequest(
  request: PilotAccessRequest,
) {
  const response = await api.post(
    "/api/platform/pilot-requests",
    request,
  );

  return response.data;
}